/** @jsx jsx */
import { jsx } from '@emotion/react';

import * as React from 'react';

import { Typography } from '@coursera/cds-core';

import Loader from 'bundles/degree-home/components/Loader';
import { CurrentCourses } from 'bundles/degree-home/components/v2/CurrentCourses/CurrentCourses';
import EmptyCompletedCoursesMessage from 'bundles/degree-home/components/v2/CurrentCourses/EmptyCompletedCoursesMessage';
import { Card } from 'bundles/program-loggedin-shared/components/Card';

import _t from 'i18n!nls/degree-home';

import { useCoursesContext } from '../CoursesProvider';

export const CurrentCoursesCard = () => {
  const { coursesLoading, inProgressCoursesData } = useCoursesContext();
  const hasInProgressCourses = inProgressCoursesData && inProgressCoursesData.length > 0;

  return (
    <Card aria-label={_t('Current courses')} data-e2e="current-courses-card">
      {/* eslint-disable-next-line @coursera-web/custom-rules/prefer-cds-typography2 -- FIXME: legacy; migrate to Typography2 */}
      <Typography component="h2" variant="h2semibold" color="body">
        {_t('Current courses')}
      </Typography>
      {(() => {
        if (hasInProgressCourses) {
          return <CurrentCourses inProgressCourses={inProgressCoursesData} />;
        } else if (coursesLoading) {
          return <Loader />;
        } else {
          return <EmptyCompletedCoursesMessage />;
        }
      })()}
    </Card>
  );
};

export default CurrentCoursesCard;
